module.exports = __webpack_public_path__ + "img/service-active.24504e2c.svg";